// useDailyAdsMap.js
import { useMemo } from "react";

export const useAdsMap = (adsData = []) => {
  return useMemo(() => {
    const map = {};

    for (const row of adsData) {
      const date = row.segments?.date;
      if (!date) continue;

      if (!map[date]) {
        map[date] = {
          impressions: 0,
          clicks: 0,
          conversions: 0,
          costMicros: 0,
        };
      }

      map[date].impressions += +row.metrics?.impressions || 0;
      map[date].clicks += +row.metrics?.clicks || 0;
      map[date].conversions += +row.metrics?.conversions || 0;
      map[date].costMicros += +row.metrics?.costMicros || 0;
    }

    return map;
  }, [adsData]);
};
